import Swiper, {
  Autoplay, FreeMode, Navigation, Pagination,
} from 'swiper';

export default Swiper;
export {
  Autoplay, FreeMode, Navigation, Pagination,
};
